<template>
  <n-loading-spinner v-if="!workspaceLoaded" style="margin: 4rem auto" />
  <UsersInWorkspace v-else :provided-workspace="workspace" />
</template>

<script setup lang="ts">
import { computed, onMounted, ref } from 'vue';
import WorkspaceViewModel from '@/workspaces/models/workspaceViewModel';
import { useRoute } from 'vue-router';
import { workspacesApi } from '@/workspaces/workspaces';
import UsersInWorkspace from '@/features/settings/views/UsersInWorkspace.vue';

const route = useRoute();
const workspaceId = computed(() => <string>route.params.id);
const workspace = ref<WorkspaceViewModel>();

const workspaceLoaded = computed(() => !!workspace.value);

onMounted(async () => {
  workspace.value = await workspacesApi.getById(workspaceId.value);
});
</script>
